import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { axiosThrottle } from "@/utils/method";
import { waitRes } from "@/utils/axios";
import { businessApply, businessgetNewestByCode } from "@/api/xt-user";

interface NoApiProps extends BaseCompProps {
  attr?: any;
}
interface ApiAuditInfoProps {
  businessCode: string;
  /**审核不通过原因 */
  remark: string;
  /**审核结果 0:不通过 1:通过 */
  result: number;
  /**审核状态 0：待审核 1：已审核*/
  status: number;
}
const { useTranslation } = Hooks;
const businessCode = "2b3f5af3f615bae5";
const NoApi: React.FC<NoApiProps> = ({ className }) => {
  const t = useTranslation();
  // const { notSub, userAuthLevel } = store.user;
  const [isOpenApi, setIsOpenApi] = useState<WithNull<ApiAuditInfoProps>>(null);
  // const [open, setOpen] = useState(false);
  /**useEffect */
  useEffect(() => {
    store.user.getAuthInfo();
    getBusinessAuditInfo();
  }, []);

  /**method */
  const openApplyApi = () => {
    submitApply();
    // if (userAuthLevel < 2) {
    //   ModelAlert.confirm({
    //     center: true,
    //     // icon:false,
    //     content: t('account.pleaseCompleteName'),
    //     okText: t("account.VerifyNow"),
    //     cancelText: t("account.close"),
    //     onOk: () => {
    //       router.push("/accounts/user/verification");
    //     },
    //   });
    // } else {
    // setOpen(true);
    // }
  };
  const getBusinessAuditInfo = async () => {
    const { data, err } = await waitRes(businessgetNewestByCode, {
      params: { businessCode },
    });
    if (err) return;
    setIsOpenApi(data || null);
  };
  const submitApply = axiosThrottle(async (unlock) => {
    const { data, err } = await waitRes(businessApply, { bizId: "bizId" + new Date().getTime(), businessCode });
    unlock();
    if (err) return;
    getBusinessAuditInfo();
    window.location.reload();
  });
  return (
    <div className={cx(styles.noapi, className)}>
      <div className={styles["content"]}>
        <p>
          {t("saas.account.conductreal-timetransactions")} 
        </p>
        <div className={styles["btn_class"]}>
          {!isOpenApi && (
            <div className={styles["btn"]} onClick={() => openApplyApi()}>
              {t("account.CreateAPI")}
            </div>
          )}
          {isOpenApi && isOpenApi.status === 0 && <div className={styles["btn"]}>{t("fund.UnderReview")}</div>}
          {isOpenApi && isOpenApi.status === 1 && isOpenApi.result === 0 && (
            <div className={cx(styles["btn"], styles["btn_fail"])} onClick={openApplyApi}>
              {t("account.aginSubmit")}
            </div>
          )}
          {isOpenApi && isOpenApi.status === 1 && isOpenApi.result === 0 && isOpenApi.remark && (
            <p className={styles["fail_reason"]}>
              {t("account.reason")}: {isOpenApi.remark}
            </p>
          )}
        </div>
        <p className={styles["api_view"]}>
          <a target="_blank" href="https://doc.xt.com/" rel="noreferrer">
            {t("account.viewcontent")}
          </a>
        </p>
      </div>

      {/* <Modal open={open} title={t("account.CreateAPI")} width={600} footer={null} onCancel={() => setOpen(false)}>
        <div className={styles["noapimodal"]}>
          <div>{t("account.tocontroller5000usdt")}</div>
          <div className={styles["sureApply"]} onClick={submitApply}>
            <span>{t("account.submitApply")}</span>
          </div>
        </div>
      </Modal> */}
    </div>
  );
};
export default observer(NoApi);
